import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Studio from "./components/Studio";
import Booking from "./components/Booking";
import Contact from "./components/Contact";
import Apply from "./components/Apply";
import Landing from "./components/Landing";
import Artist from "./components/Artist";
import Footer from "./components/Footer";
import Aftercare from "./components/Aftercare";
import BookingButton from "./components/BookingButton";
import LanguageModal from "./components/LanguageModal";  // Import LanguageModal
import { LanguageProvider } from "./components/LanguageContext";
import { useState, useEffect } from "react";
import AOS from "aos";
import 'aos/dist/aos.css';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(true);

  // Close modal when language is selected
  const handleLanguageChange = () => {
    setIsModalOpen(false);
  };

  useEffect(()=>{
    AOS.init({
      duration: 1000,   // Animation duration in ms
      easing: "ease-in-out",  // Animation easing
      offset: 120,  // Trigger animations after scrolling 120px
      delay: 0,  // Animation delay
        // Only animate once
    });
  })

  return (
    <LanguageProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          {/* Language Modal */}
          {isModalOpen && <LanguageModal onClose={handleLanguageChange} />}

          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/artist" element={<Artist />} />
              <Route path="/aftercare" element={<Aftercare />} />
            </Routes>
            <BookingButton />
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
